ixModuleRouting("impactx.bank", {
    "/banklist": {
        template: "<ixa-bank-list></ixa-bank-list>",
        process: "ListBank",
        workspace: "admin",
    },
    "/bank/:id": {
        template: "<ixa-bank></ixa-bank>",
        process: "EditBank",
        workspace: "admin",
    },
});
